import React, { Component } from "react";

import { req_list_cslc_public_works, req_list_cslc_public_lottery } from "../api";
import { Tag, Collapse } from "antd";
// import { Row, Col, Card } from 'antd';
// import image5 from './assets/images/unnamed.jpg'
import image from './assets/images/littlebobo.jpg'

// const { Meta } = Card;
const { Panel } = Collapse;

export default class ViewSurvey extends Component {
    state = {
        loading: false,
        workitems: [],
        voteritems: [],
        item: {},
        enrollCode: "",
        startVoting: false /* VOTE_PROGRESS */,
        voteStatus: "CLOSE" /* CLOSE/VOTE_NOTBEGIN/VOTE_END */,
        voteActivity: "2022-1001-00001",
    };
    UNSAFE_componentWillMount() {
        this.api_list_workitems();
        this.api_list_voteritems();
    }

    api_list_workitems = async () => {

        this.setState({ loading: true, workitems: [] });
        const result = await req_list_cslc_public_works("");
        this.setState({ loading: false });

        //console.log(result)
        if (result.total > 0) {
            const { data } = result;
            const workitems = data;

            this.setState({ workitems });
            //console.log(items);
        } else {
            const workitems = [];
            this.setState({ workitems });
        }
    };

    api_list_voteritems = async () => {

        this.setState({ loading: true, voteritems: [] });
        const result = await req_list_cslc_public_lottery("");
        this.setState({ loading: false });

        //console.log(result)
        if (result.total > 0) {
            const { data } = result;
            const voteritems = data;

            this.setState({ voteritems });
            // console.log('voteritems:', voteritems);
        } else {
            const voteritems = [];
            this.setState({ voteritems });
        }
    };
    style_switch_color_tag(column, type) {
        let ans = "black";
        switch (type) {
            case "awardlevel":
                switch (column) {
                    case 0:
                        ans = "Yellow";
                        break;
                    case 1:
                        ans = "WhiteSmoke";
                        break;
                    case 2:
                        ans = "Peru";
                        break;
                    default:
                        // OTHER
                        ans = "#1B4F72";
                        break;
                }
                break;
            default:
                ans = "#1B4F72";
                break;
        }
        return ans;
    }
    ////////////////////////////////////////////////
    render() {
        const { loading, voteritems } = this.state;
        return (
            <div id="survey" className='block surveyBlock gbGray' >
                <div className="container-fluid">
                    <div className="titleHolder">
                        <h2><img alt="bobo" src={image} width="60px" />票選抽獎活動</h2>
                        <span>(限定南應大教職員生參加)</span>
                    </div>
                    <Collapse defaultActiveKey={['1']}>
                        <Panel header="抽獎活動" key="1">
                            <p></p>
                            <ol className='item'>
                                <li>票選活動時間：111年10月14日-10月24日止</li>
                                <li>票選方式：請至<a href="https://portal.tut.edu.tw/" style={{ textDecoration: "underline", backgroundColor: "gray", color: "white" }}>南應大入口/應用系統/「TUT虛擬數位形象大使」票選系統</a>投票，經本校評選委員會進行初選後, 共選出16組作品進入決選, 每個人(個人帳號)僅能投票一次(至多可圈選3件)最優秀的作品。</li>
                                <li>抽獎活動：
                                    <ol className='item' type="I">
                                        <li><span style={{ color: "green" }}>伯樂獎</span>：從所有參與票選人中抽出50名，每人可獲得100元禮券。抽獎時間：10月26日由電腦抽出，公告在活動網頁。(每人限得獎一次)</li>
                                        <li><span style={{ color: "red" }}>慧眼獨具獎</span>：投票作品進入第一名者，另抽出5名獲得300元禮券。(每人限得獎一次，但不包括已獲得伯樂獎者)</li>
                                    </ol>
                                </li>
                                {/* <li>抽獎時間：作品甄選名次公告後由電腦抽出，公布於活動網頁。</li> */}
                                <li><strong style={{ color: "blue" }}>領獎流程：準備南應大身分辨識證件(如學生證,職員證等)，根據獲獎項目，簽收領取等值禮卷</strong></li>
                                <li><strong style={{ color: "blue" }}>領獎地點：至南應大教育大樓一樓通識中心辦公室(E110)，找負責人翁筱婷小姐(TEL：#350) </strong></li>
                                <li><strong style={{ color: "blue" }}>領獎期限：</strong><span style={{ backgroundColor: "red", color: "white" }}>請於2022.12.02(五)下午4點前領取</span></li>
                            </ol>
                        </Panel>
                    </Collapse>
                    {loading ? (
                        <div >
                            <div className="text-center">
                                <button
                                    className="btn btn-light text-dark"
                                    type="button"
                                    disabled
                                >
                                    <span
                                        className="spinner-border spinner-border-sm"
                                        role="status"
                                    ></span>{" "}
                                    查詢中 ......
                                </button>
                            </div>
                        </div>
                    ) : (
                        <>
                            <p></p>
                            {voteritems.length > 0 ? (
                                <>
                                    <div className="container">
                                        <div className="table-responsive">
                                            <table className="table table-striped table-sm">
                                                <thead >
                                                    <tr style={{ backgroundColor: "#380F7B", color: "#FFFFFF" }}>
                                                        <th style={{ textAlign: "center", backgroundColor: "#773704" }} className="d-none d-sm-block">獎項</th>
                                                        <th style={{ textAlign: "center" }}>職/學號</th>
                                                        <th style={{ textAlign: "center" }}>姓名</th>
                                                        <th style={{ textAlign: "center" }}>中獎內容</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {voteritems.map((item, index) => {
                                                        return (<>
                                                            <tr>
                                                                <td style={{ textAlign: "center", color: item.PrizeName === "伯樂獎" ? "green" : "red" }} className="d-none d-sm-block">{item.PrizeName}</td>
                                                                <td style={{ textAlign: "center", color: item.PrizeName === "伯樂獎" ? "green" : "red" }}>{item.WinnerId}</td>
                                                                <td style={{ textAlign: "center", color: item.PrizeName === "伯樂獎" ? "green" : "red" }} >{item.WinnerMarkName}</td>
                                                                <td style={{ textAlign: "center", color: item.PrizeName === "伯樂獎" ? "green" : "red" }}>{item.PrizeName === "伯樂獎" ? "100元禮券" : "300元禮券"}</td>
                                                            </tr>
                                                        </>)
                                                    })}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>

                                </>) : (<div style={{ textAlign: "center" }}>
                                    <Tag color="gray" style={{ margin: "10px" }}>
                                        無人中獎
                                    </Tag>
                                </div>)}
                        </>
                    )}

                    {/* <Row gutter={[16, 16]}>
                        <Col xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 8 }}>
                            <Card
                                hoverable
                                cover={<img alt="advanced option" src={image5} />}>
                                <Meta title="作品尚未開放" />
                            </Card>
                        </Col>
                        <Col xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 8 }}>
                            <Card
                                hoverable
                                cover={<img alt="clean-design" src={image5} />}>
                                <Meta title="作品尚未開放" />
                            </Card>
                        </Col>
                        <Col xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 8 }}>
                            <Card
                                hoverable
                                cover={<img alt="easy customise" src={image5} />}>
                                <Meta title="作品尚未開放" />
                            </Card>
                        </Col>
                    </Row> */}
                    {/* <p></p>
                    {loading ? (
                        <div >
                            <div className="text-center">
                                <button
                                    className="btn btn-light text-dark"
                                    type="button"
                                    disabled
                                >
                                    <span
                                        className="spinner-border spinner-border-sm"
                                        role="status"
                                    ></span>{" "}
                                    查詢中 ......
                                </button>
                            </div>
                        </div>
                    ) : (
                        <>
                            {items.length > 0 ? (
                                <>
                                    {" "}
                                    <div className="container">
                                        <div className="row">
                                            {items.map((item, index) => {
                                                return (
                                                    <div
                                                        className="col-md-3"
                                                        key={index}
                                                        style={{ marginBottom: "10px" }}
                                                    >
                                                        <div className="thumbnail colstyle" key={index}>
                                                            <div
                                                                style={{
                                                                    width: "100%",
                                                                    textAlign: "center",
                                                                    backgroundColor: "#800080",
                                                                    color: "white",
                                                                }}
                                                            >
                                                                <span style={{ color: "yellow" }}>
                                                                    編號：{item.WorksCode}
                                                                </span>
                                                            </div>
                                                            <div className="caption">
                                                                <Collapse accordion>
                                                                    <Panel
                                                                        header={
                                                                            <>
                                                                                創作理念
                                                                                <span
                                                                                    style={{
                                                                                        fontSize: "12px",
                                                                                        color: "gray",
                                                                                    }}
                                                                                >
                                                                                    (點此可看)
                                                                                </span>
                                                                            </>
                                                                        }
                                                                        key="2"
                                                                    >
                                                                        <p>{item.Description}</p>
                                                                    </Panel>
                                                                </Collapse>
                                                            </div>
                                                            <div style={{ textAlign: "center" }}>
                                                                <Image
                                                                    width={"250px"}
                                                                    height={"150px"}
                                                                    src={DEFAULT_IMAGE_URL + item.AttachedfileA}
                                                                />
                                                                <Image
                                                                    width={"250px"}
                                                                    height={"150px"}
                                                                    src={DEFAULT_IMAGE_URL + item.AttachedfileB}
                                                                />
                                                                <h6
                                                                    style={{
                                                                        color: "gray",
                                                                        marginTop: "2px",
                                                                        fontSize: "0.6em",
                                                                    }}
                                                                >
                                                                    (點圖可放大)
                                                                </h6>
                                                            </div>
                                                        </div>
                                                        <div
                                                            className="titleMame"
                                                            style={{ textAlign: "center", backgroundColor: "#1B4F72" }}
                                                        >

                                                            <div
                                                                style={{
                                                                    textAlign: "center",
                                                                    margin: "auto",
                                                                }}
                                                            >
                                                                <span>
                                                                    作品名稱：{item.Title}
                                                                </span>
                                                            </div>

                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                </>
                            ) : (
                                <div style={{ textAlign: "center" }}>
                                    <Tag color="gray" style={{ margin: "10px" }}>
                                        尚無入選作品
                                    </Tag>
                                </div>
                            )}
                        </>
                    )} */}
                </div>
            </div >
        )
    }
}
